import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ExportResquestForm } from '@gnv-shared/types';

@Injectable({
  providedIn: 'root'
})
export class ExportRequestFormModificationTrackerService {
  private _isModified = false;
  private _form?: FormGroup<ExportResquestForm>;

  setModified(state: boolean) {
    this._isModified = state;
  }

  isModified(): boolean {
    return this._isModified || (this._form ? this._form.dirty : false);
  }

  trackForm(form: FormGroup<ExportResquestForm>) {
    this._form = form;
  }
}
